module.exports = __webpack_public_path__ + "static/media/cable.6b639557.jpg";